import { Button, Checkbox, Image, Modal } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import loginWhite from '@/assets/login-white.png';
import loginBlack from '@/assets/login-black.png';
import { GoogleOutlined, FacebookOutlined, WindowsOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LoginModal = props => {
  const { isLoginModalOpen, handleLoginModalClose, handleLogin } = props;
  const { themeMode } = useSelector(state => state.global);
  const [isTermsAgreed, setIsTermsAgreed] = useState(false);
  const { t } = useTranslation('home', 'translation');

  return (
    <Modal
      open={isLoginModalOpen}
      onCancel={handleLoginModalClose}
      footer={null}
      centered
      width={400}
    >
      <div style={{ textAlign: 'center' }}>
        <br />
        <h2>Scams Report</h2>
        <br />
        <h1>{t('home:welcome')}!</h1>
        <br />
        <Image src={themeMode === 'dark' ? loginBlack : loginWhite} preview={false} width={150} />
        <br />
        <br />
        <p>{t('home:effect')}</p>
        <br />
        <Checkbox onChange={e => setIsTermsAgreed(e.target.checked)}>
          {t('home:agreePrefix')}
          <a
            href="https://www.scams.report/policy/terms-of-use.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            {t('home:termsLink')}
          </a>
          .
        </Checkbox>
        <br />
        <br />
        <Button
          icon={<GoogleOutlined />}
          type="primary"
          className="login-button google"
          onClick={() => handleLogin('google')}
          disabled={!isTermsAgreed}
        >
          {t('home:continueGoogle')}
        </Button>
        <Button
          icon={<FacebookOutlined />}
          type="primary"
          className="login-button facebook"
          onClick={() => handleLogin('facebook')}
          disabled={!isTermsAgreed}
        >
          {t('home:continueFacebook')}
        </Button>
        <Button
          icon={<WindowsOutlined />}
          type="primary"
          className="login-button microsoft"
          onClick={() => handleLogin('microsoft')}
          disabled={!isTermsAgreed}
        >
          {t('home:continueMicrosoft')}
        </Button>
      </div>
    </Modal>
  );
};

export default LoginModal;
